import { css } from '@emotion/react'

export const mobileDirectionColumn = css`
  @media (max-width: 600px) {
    flex-direction: column !important;
  }
`
